// eslint-disable-next-line no-extend-native
String.prototype.isEmpty = function() {
	return (this.length === 0 || !this.trim());
};


// WEBPACK FOOTER //
// ./src/extensions/string.js